import client from './client';

export interface AiGenerateBaseItem {
  id: string;
  name: string;
  industry: string[];
  tier: string;
  version: string;
  description: string;
  points: number;
  models: number;
  tags?: string[];
  /** A3 权限模型 */
  access?: string[];
  accessible?: boolean;
  trial?: boolean;
  lockReason?: string | null;
  canExport?: boolean;
}

export interface AiGenerateTaskResult {
  sceneId: string | null;
  pageId: string | null;
  refs: Record<string, unknown> | null;
}

export interface AiGenerateTask {
  id: string;
  status: string;
  stage: string;
  progress: number;
  baseId: string | null;
  prompt: string;
  warnings: string[];
  error?: string | null;
  result: AiGenerateTaskResult;
  createdAt: string;
  startedAt?: string | null;
  finishedAt?: string | null;
}

export interface CreateAiGenerateInput {
  prompt: string;
  baseId?: string;
  scopes?: string[];
  deviceId?: string;
  bindPointKey?: string;
  model?: string;
}

export async function fetchAiGenerateBases(): Promise<AiGenerateBaseItem[]> {
  const { data } = await client.get('/ai/generate/bases');
  return data;
}

export async function createAiGenerateTask(body: CreateAiGenerateInput): Promise<{ taskId: string; status: string }> {
  const { data } = await client.post('/ai/generate', body);
  return data;
}

export async function fetchAiGenerateTask(id: string): Promise<AiGenerateTask> {
  const { data } = await client.get(`/ai/generate/${id}`);
  return data;
}

export async function fetchAiGenerateTasks(limit = 20): Promise<AiGenerateTask[]> {
  const { data } = await client.get('/ai/generate', { params: { limit } });
  return data;
}

export async function cancelAiGenerateTask(id: string): Promise<{ canceled: boolean }> {
  const { data } = await client.post(`/ai/generate/${id}/cancel`);
  return data;
}
